// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 736 ? "userInfo" : chunkId) + "-legacy." + {"262":"cf409baf","580":"f410dccd","581":"5225d4cd","736":"c85a10d4","922":"f4530df5","979":"bb8cc5ff"}[chunkId] + ".js";
};